export default function VisitorPortrait({ src }) {
  if (src) {
    return (
      <div className="vis-portrait">
        <img src={src} alt="Scanned ID" />
      </div>
    );
  }

  return (
    <div className="vis-portrait" aria-label="No ID photo">
      <svg className="vis-portrait-fallback" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="20" r="10" fill="none" stroke="#111111" strokeWidth="3" />
        <path d="M10 54c2.2-12 10.4-18 22-18s19.8 6 22 18" fill="none" stroke="#111111" strokeWidth="3" strokeLinecap="round" />
      </svg>
    </div>
  );
}
